import request from 'utils/request'

/*---------  担保及保险    -------*/

//担保及保险列表
export const getAssurance = data => request().post('assurance/page', data)
//下载
export const downloadAssurance = id =>
  request().get(`assurance/download/${id}`, { responseType: 'blob' })
//失效
export const deleteAssurance = id => request().get(`assurance/disable/${id}`)
//添加
export const addAssurance = data => request().post('assurance/add', data)
// uploadAssurance
export const uploadAssurance = data => {
  return request().post('assurance/upload', data)
}
//导出
export const exportAssurance = id =>
  request().get(`assurance/export/${id}`, { responseType: 'blob' })
//查询companyCode 和 permissions
export const getOverview = id => request().get(`customer/overview/${id}`)
